var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickuptruckBlueBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 114,
    viewBox: "0 0 165 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pickuptruck-blue-bg",
    transform: "translate(-45 -808)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 165,
    height: 114,
    rx: 20,
    transform: "translate(45 808)",
    fill: "#04a8e8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Pickup_Truck",
    "data-name": "Pickup Truck",
    transform: "translate(76 899)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PICKUP TRUCK")), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(-1470.139 -1670.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M1600.139,2507.391c2.877,0,.506,13.557,3,13.531,13.715-.145,37.321.031,51.036,0,5.248-.013,6.229.65,5.878,5.931-.29,4.362,1.486,8.222,1.878,12.374.286,3.006-.911,4.646-4,4.808a42.932,42.932,0,0,0-4.29.388c-3.475.537-5.279-.414-6.015-4.346-1.008-5.378-6.308-8.868-11.831-8.792a11.778,11.778,0,0,0-11.693,9.452c-.646,3.143-1.984,3.687-4.9,3.653-15.034-.179-30.072-.166-45.108-.083-2.707.015-4.146-.477-4.736-3.545a12.28,12.28,0,0,0-23.875-.146c-.6,2.36-1.356,3.8-4.171,3.454-2.885-.35-2.829-2.4-2.9-4.378-.063-1.679-.678-3.513,1.18-4.856.428-.31.349-1.432.368-2.184.207-8.534.21-8.49,8.515-10.33a111.816,111.816,0,0,1,14.757-2.274,9.452,9.452,0,0,0,5.927-2.486c.653-.6,1.412-1.085,2.036-1.711C1577.813,2509.209,1590.41,2505.341,1600.139,2507.391Zm-23.649,13.846c5.74,0,10.931-.037,16.121.023,1.471.017,4.968.543,5.195-1.214.408-3.143-.391-6.867,0-9.988-9.567-1.694-18.689-.018-24.426,8.405C1574.892,2518.7,1577.045,2518.484,1576.49,2521.237Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M1568.525,2547.089c0,5.443-4.906,10.585-10.108,10.268-5.949-.363-9.543-4.81-9.752-10.158a9.93,9.93,0,0,1,19.86-.11Z",
    transform: "translate(-1.175 -3.445)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M1647.463,2537.25a10.009,10.009,0,0,1,9.682,10.2c-.16,4.949-5.443,10.175-10.165,10.054-5.264-.137-9.786-5.114-9.683-10.659A9.724,9.724,0,0,1,1647.463,2537.25Z",
    transform: "translate(-11.19 -3.446)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickuptruckBlueBg);
export default __webpack_public_path__ + "static/media/pickuptruck-blue-bg.476d789dba32874de50494936d833fc1.svg";
export { ForwardRef as ReactComponent };